<script setup lang="ts">
import { computed, defineAsyncComponent, Transition } from 'vue';
import Lazy from '@/components/Lazy.vue';
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
import { VUE_APP_BASE_URL } from '@/env';
import MainNavShell from '@/components/MainNavShell.vue';

const WhatsApp = defineAsyncComponent({
    loader: () => import(/** webpackChunkName: "WhatsApp" */ '@/components/WhatsApp.vue')
});

const CookiesBar = defineAsyncComponent({
    loader: () => import(/** webpackChunkName: "CookiesBar" */ '@/components/CookiesBar.vue')
});

const MainNav = defineAsyncComponent({
    loader: () => import(/* webpackChunkName: "MainNav" */ '@/components/MainNav.vue')
});

const route = useRoute();

const canonicalUrl = computed(() => {
    return VUE_APP_BASE_URL + route.path;
});


useHead({
    link: [
        {
            rel: 'canonical',
            href: canonicalUrl
        }
    ]
});

</script>
<template>
    <Suspense>
        <Lazy>
            <MainNav />
        </Lazy>
        <template #fallback>
            <MainNavShell />
        </template>
    </Suspense>

    <div class="router-wrapper">
        <RouterView v-slot="{ Component }">
            <Transition name="fade" mode="default">
                <component :is="Component" />
            </Transition>
        </RouterView>
    </div>

    <!-- COOKIES BAR -->
    <Suspense>
        <Lazy>
            <CookiesBar />
        </Lazy>
    </Suspense>
    <!-- WHATSAPP -->
    <Suspense>
        <Lazy>
            <WhatsApp />
        </Lazy>
    </Suspense>
</template>
<style lang="scss">
@import '@/assets/sass/main.scss';

.router-wrapper {
    position: relative;
    width: 100%;
}

.fade-enter-active,
.fade-leave-active {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    transition: opacity 0.2s ease-in-out;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
</style>
